import { render, staticRenderFns } from "./IndicatorRadioGroup.vue?vue&type=template&id=2c499068&"
import script from "./IndicatorRadioGroup.vue?vue&type=script&lang=js&"
export * from "./IndicatorRadioGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports